export class ClaimDetailsItem {
    constructor(
        public IdCliente: string,
        public ClaimNumber: String,
        public DealerCode: string,
        public CompanyCode: string
    ){}
}
